/**
 * Updates the recently viewed products in localStorage.
 */
// export class RecentlyViewed {
//   /** @static @constant {string} The key used to store the viewed products in session storage */
//   static #STORAGE_KEY = 'viewedProducts';
//   /** @static @constant {number} The maximum number of products to store */
//   static #MAX_PRODUCTS = 4;

//   /**
//    * Adds a product to the recently viewed products list.
//    * @param {string} productId - The ID of the product to add.
//    */
//   static addProduct(productId) {
//     let viewedProducts = this.getProducts();

//     viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
//     viewedProducts.unshift(productId);
//     viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

//     localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
//   }

//   static clearProducts() {
//     localStorage.removeItem(this.#STORAGE_KEY);
//   }

//   /**
//    * Retrieves the list of recently viewed products from session storage.
//    * @returns {string[]} The list of viewed products.
//    */
//   static getProducts() {
//     return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
//   }
// }

//  new  

class RecentlyViewedProducts extends HTMLElement {
  constructor() {
    super();
    this.storageKey = 'shopify_recently_viewed';
    this.maxStored = 20;
    this.debug = new URLSearchParams(window.location.search).has('rvdebug');
  }

  connectedCallback() {
    const currentId = this.dataset.currentProductId;
    this.log('Init. Current product ID:', currentId || '(none — not on product page)');

    if (currentId) {
      this.trackProduct(currentId);
      this.log('Tracked product:', currentId);
    }

    this.log('localStorage contents:', JSON.stringify(this.getViewed()));
    this.render();
  }

  trackProduct(productId) {
    const id = String(productId);
    let viewed = this.getViewed();
    viewed = viewed.filter((pid) => pid !== id);
    viewed.unshift(id);
    viewed = viewed.slice(0, this.maxStored);
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(viewed));
    } catch (e) {
      this.log('localStorage write failed:', e.message);
    }
  }

  getViewed() {
    try {
      return JSON.parse(localStorage.getItem(this.storageKey)) || [];
    } catch {
      return [];
    }
  }

  async render() {
    const currentId = this.dataset.currentProductId;
    const max = parseInt(this.dataset.productsToShow, 10) || 8;
    const stored = this.getViewed();
    let ids = stored.filter((pid) => pid !== currentId).slice(0, max);

    this.log('IDs after filtering current:', JSON.stringify(ids));

    if (ids.length === 0) {
      this.log('No IDs to render. Showing empty state.');
      this.showEmptyState();
      return;
    }

    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const url = `${this.dataset.url}${encodeURIComponent(query)}`;
    this.log('Fetch URL:', url);

    try {
      const response = await fetch(url);
      this.log('Response status:', response.status);
      if (!response.ok) throw new Error(`HTTP ${response.status}`);

      const html = await response.text();
      this.log('Response HTML length:', html.length, 'chars');

      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-products-container]');
      const target = this.querySelector('[data-products-container]');

      this.log('Fresh container found in response:', !!fresh);
      this.log('Fresh container child count:', fresh?.children.length ?? 'n/a');
      this.log('Target container in DOM:', !!target);

      if (fresh && target) {
        target.innerHTML = fresh.innerHTML;
        if (target.children.length === 0) {
          this.log('Target empty after replace. Showing empty state.');
          this.showEmptyState();
        } else {
          this.log('Successfully rendered', target.children.length, 'cards.');
        }
      } else {
        this.log('Container missing. Showing empty state.');
        this.showEmptyState();
      }
    } catch (err) {
      this.log('Fetch failed:', err.message);
      this.showEmptyState();
    }
  }

  showEmptyState() {
    const template = this.querySelector('template[data-empty-state]');
    const container = this.querySelector('[data-products-container]');
    if (template && container) {
      container.replaceWith(template.content.cloneNode(true));
    } else {
      this.hidden = true;
    }
  }

  log(...args) {
    console.log('[RecentlyViewed]', ...args);
    if (!this.debug) return;
    let panel = document.getElementById('rv-debug-panel');
    if (!panel) {
      panel = document.createElement('pre');
      panel.id = 'rv-debug-panel';
      panel.style.cssText =
        'position:fixed;bottom:0;left:0;right:0;max-height:40vh;overflow:auto;' +
        'background:#000;color:#0f0;font:12px monospace;padding:10px;z-index:99999;' +
        'margin:0;white-space:pre-wrap;border-top:2px solid #0f0;';
      document.body.appendChild(panel);
    }
    panel.textContent +=
      args.map((a) => (typeof a === 'object' ? JSON.stringify(a) : String(a))).join(' ') + '\n';
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);